<script lang="ts">
    import type { MediaImageFragment } from '$gql/graphql.js';
    import { cx } from '$lib/utils/cx.js';
    import FeedPostMedia from './FeedPostMedia.svelte';
    import ImageViewer, { createModal } from '$components/ImageViewer/ImageViewer.svelte';
    import { keepNotNull } from '$lib/utils/filterNotNull.js';
    import { melt } from '@melt-ui/svelte';

    export let medias: MediaImageFragment[];
    $: list = medias.slice(0, 4);
    $: isUniqMedia = medias?.length === 1;

    let imageViewer: ImageViewer | undefined;

    const getColClassName = (index: number, total: number) => {
        if (total === 1) return 'col-span-12';
        else if (total === 2 || total === 4) return 'col-span-6';
        else if (total === 3) {
            if (index === 0) return 'col-span-12';
            else return 'col-span-6';
        }
        return '';
    };

    $: mediaIds = keepNotNull(medias.map((media) => media.id ?? null));
    const modal = createModal({ defaultOpen: false });
    const {
        elements: { trigger },
        states: { open },
    } = modal;

    function onClickOnMedia(id: number) {
        $open = true;
        imageViewer?.selectMediaId(id);
    }
</script>

<div class={'grid grid-cols-12 gap-1'}>
    {#each list as media, index (media.id)}
        <div
            use:melt={$trigger}
            class={cx(
                'relative',
                !isUniqMedia ? 'max-h-[300px]' : '',
                getColClassName(index, list.length),
            )}
            on:click={() => onClickOnMedia(media.id)}
            on:keypress={(e) => {
                if (e.key === 'Enter') onClickOnMedia(media.id);
            }}
            tabindex={0}
            role="button"
        >
            <FeedPostMedia {media} {isUniqMedia} />
            {#if index === list.length - 1 && medias.length > list.length}
                <div
                    class={'pointer-events-none absolute w-full h-full left-0 top-0 flex items-center justify-center bg-black/25 text-white text-20'}
                >
                    +{medias.length - list.length}
                </div>
            {/if}
        </div>
    {/each}

    <ImageViewer {modal} {mediaIds} bind:this={imageViewer} />
</div>
